import { createContext, useContext, useState } from 'react';

export const DietFilterContext = createContext({
    open: false,
    setOpen: (_: boolean) => {}
});

export const DietFilterProvider = ({ children }: { children: React.ReactNode }) => {
    const [open, setOpen] = useState(false);

    return (
        <DietFilterContext.Provider value={{ open, setOpen }}>
            {children}
        </DietFilterContext.Provider>
    );
};

export const useDietFilterContext = () => {
    const context = useContext(DietFilterContext);
    if (!context) {
        throw new Error('useDietFilterContext must be used within a DietFilterProvider');
    }
    return context;
};
